/**
 * D577 (ADR-0105) — the central vocabulary catalog. Owner rule (2026-10-13, foundational): no stored code ever reaches a
 * person's screen — every status, reason, event, kind, method, role, permission and audit action a screen shows is a
 * translated, human label in every supported language. Each closed vocabulary is declared ONCE here, typed against the
 * domain's own union / const list, so the compiler refuses a missing code and the coverage test refuses a missing language.
 * There is no humanized-English fallback: an unknown code at runtime (a server newer than the screen) reads as the
 * translated "uncatalogued value", and the gate (`check:vocabulary`) keeps that from being the normal path.
 */
/** The languages every catalog entry must carry (the console base languages). Adding one fails coverage until filled. */
export const VOCAB_LANGS = ['pt', 'en', 'es', 'it'];
/** Text in the four languages, in order: pt, en, es, it. */
export function L(pt, en, es, it) {
    return { pt, en, es, it };
}
/**
 * Declare a vocabulary. Pass the domain's code type as `C` (`vocabulary<RideStatus>(…)` or
 * `vocabulary<(typeof CANCEL_REASONS)[number]>(…)`): the mapped type then demands EVERY code and refuses any extra one.
 */
export function vocabulary(id, source, labels, kind = 'label') {
    return { id, kind, source, labels };
}
//# sourceMappingURL=define.js.map